function NXManageOrder({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M8.5 0.5H5.5C4.94772 0.5 4.5 0.947715 4.5 1.5V2C4.5 2.55228 4.94772 3 5.5 3H8.5C9.05228 3 9.5 2.55228 9.5 2V1.5C9.5 0.947715 9.05228 0.5 8.5 0.5Z"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 1.5H11.25C11.5152 1.5 11.7696 1.60536 11.9571 1.79289C12.1446 1.98043 12.25 2.23478 12.25 2.5V12.5C12.25 12.7652 12.1446 13.0196 11.9571 13.2071C11.7696 13.3946 11.5152 13.5 11.25 13.5H2.75C2.48478 13.5 2.23043 13.3946 2.04289 13.2071C1.85536 13.0196 1.75 12.7652 1.75 12.5V2.5C1.75 2.23478 1.85536 1.98043 2.04289 1.79289C2.23043 1.60536 2.48478 1.5 2.75 1.5H4.25"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9L6.5 10L9.5 6"
     
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXManageOrder;
